import { numberFormatter } from '../../../../../../utils/numberFormatter/numberFormatter';
export const getRadioLabel = ({ supportersSum, type, defaultLabels }) => {
    if (supportersSum > 0) {
        const formattedNumber = numberFormatter(supportersSum);
        return `${defaultLabels[type]} (${formattedNumber})`;
    }
    return defaultLabels[type];
};
